import TimeManager from "../../../../manager/time_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export class BgVipCell extends cc.Component {
    @property(cc.Node)
    awardBtn:cc.Node = null;

    @property(cc.RichText)
    remainTime:cc.RichText = null;

    @property(cc.Label)
    timeToOver:cc.Label = null;

    updateCell(isHaveVip:boolean,data?:any){
        this.awardBtn.active = !isHaveVip;
        this.remainTime.node.active = isHaveVip;
        this.timeToOver.node.active = isHaveVip;


        if (isHaveVip) {
            let serverTime = TimeManager.instance.getServerTime() * 1000;
            let listTime = this.formatTimeDuration((data.remainTime - serverTime )/1000)
            let remainTime = '<color=#55a64d>({0}</c><color=#d75229> {1} </c><color=#55a64d>{2})</c>'.format('เหลือ',listTime,'วัน');
            this.remainTime.string = remainTime;
            let timeData = new Date(data.remainTime)
            this.timeToOver.string = timeData.format('yyyy-MM-dd') + ' หมดอายุด';
        }

    }

    protected formatTimeDuration(secs: number): string{  
        if (secs < 0) {
            return '0'
        }      
        let hour = Math.floor(secs / 3600)
        let min = Math.floor((secs - hour * 3600) / 60)
        let s = secs - hour * 3600 - min * 60
        if (hour >= 24) {
            return Math.ceil((hour / 24)) + ''
        }
        return '1';
    }

    reset(){
        
    }
}
